import { jsx as _jsx } from "react/jsx-runtime";
import { Drawer } from "@mantine/core";
import { useOverlayZIndex } from "./useOverlayZIndex";
/**
 * Drop-in replacement for Mantine's Drawer that automatically gets a
 * z-index higher than any previously opened overlay (modal or drawer).
 *
 * Drawer.Stack is still re-exported from Mantine for drawer-to-drawer
 * offset behavior — AppDrawer handles the cross-type stacking.
 */
export const AppDrawer = ({ opened, zIndex, ...rest }) => {
    const autoZIndex = useOverlayZIndex(opened);
    return _jsx(Drawer, { opened: opened, zIndex: zIndex ?? autoZIndex, ...rest });
};
